import { Spinner } from "@chakra-ui/react";

export const LoadingSpinner: React.FC = () => {
  return <Spinner size="xl" />;
};
